// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Y31o","obliqueLineWrap":"membershipbadge_obliqueLineWrap__33LLr","obliqueLine":"membershipbadge_obliqueLine__QfWIw"};